<template>
  <div class="main_dialog right_set">
    <div class="main_dialog_frame">
      <div
        class="close_edit_panel_btn"
        @click="dialog_close">
        <i class="close_edit_panel_icon el-icon-close"></i>
      </div>
      <div class="main_dialog_content">
        <div class="layout_row_edit">
        <el-tabs class="edit_top_tabs children_is_tab" v-model="activeName">
              <el-tab-pane :label="$t('view_public_topbar_4')" name="setting">
                <div class="edit_item">
                    <el-collapse v-model="activeName2" accordion>
                      <el-collapse-item :title="$t('view_right_set_index_56')" name="base" class="text_set_warp">
                          <div class="checkbox_item">
                            <el-checkbox
                              v-model="$store.state.myRender.common.setting.footnavOpen"
                              @change="(e)=>{footnav_isShow(e,'basic_footnav')}"
                            >{{$t('view_right_set_index_57')}}</el-checkbox>
                            <span
                              v-if="$store.state.myRender.common.setting.footnavOpen"
                              @click="open_set('basic_footnav')"
                            >{{$t('view_right_set_index_58')}}</span>
                          </div>

                          <div class="checkbox_item">
                            <el-checkbox
                              v-model="$store.state.myRender.common.setting.headerSearchOpen"
                              @change="(e)=>{openHeaderSearch(e)}"
                            >{{$t('view_right_set_index_59')}}</el-checkbox>
                            
                          </div>
                      </el-collapse-item>
                    </el-collapse>
                </div>
              </el-tab-pane>
            </el-tabs>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import i18n from '../../language/index'

  export default {
    name: "right_set",
    watch: {
    },
    data () {
      return {
        activeName: 'setting',
        activeName2: 'base'
      };
    },
    components: {
    },
    mounted () {
      //左侧框拖拽
      $('.right_set').draggable({
        containment:'window'
      });
      this.$nextTick(() => {
        this.templet.left_sidebar_draggable()
      })
    },
    methods: {
      dialog_close () {
        this.$store.commit('right_set/set_dialog', false);
      },
      open_set(name) {
        const id = $('.' + name).attr('data-id')
        const module = this.templet.find_obj(id)
        if (module) {
          // 打开底部服务栏弹框
          this.$store.commit('app/SET_module_Data', module.target)
          this.$store.commit('main_dialog/Change_main_dialog_isShow', true)
          this.$store.commit('main_dialog/Change_edit_name', name)
          // 关闭基础设置弹框
          this.$store.commit('right_set/set_dialog', false)
        }
      },
      openHeaderSearch(val){
        this.templet.create_mb_basic_searchs(val)
        this.$nextTick(()=> {
          this.$store.commit('myRender/SET_HEADER_SEARCH', val)          
        })
      },
      footnav_isShow(val, name) {
        if (val) {
          this.templet.footnav_isShow(name)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .main_dialog {
  position: fixed;
  top: 100px;
  right: 150px;
  width: 384px;
  height: -webkit-calc(100% - 80px);
  height: -moz-calc(100% - 80px);
  height: calc(100% - 80px);
  max-height: 740px;
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  -webkit-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.2);
  z-index: 2000;
  .main_dialog_frame {
    position: relative;
    width: 100%;
    height: 100%;
    /*overflow-y: auto;*/
    .close_edit_panel_btn {
      position: absolute;
      top: 0;
      right: 0;
      width: 58px;
      height: 58px;
      cursor: pointer;
      line-height: 48px;
      font-size: 30px;
      text-align: center;
      z-index: 10;
      color: #fff;
      i {
        font-size: 18px;
      }
    }
    .main_dialog_content {
      height: 100%;
    }
    .main_dialog_header {
      font-family: "微软雅黑";
      overflow: hidden;
      width: 100%;
      height: 58px;
      font-size: 0;
      background: #5874d8;
      -webkit-border-radius: 5px 5px 0 0;
      -moz-border-radius: 5px 5px 0 0;
      border-radius: 5px 5px 0 0;
    }
  }
}
.checkbox_item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin: 8px 0 11px 18px;
  font-size: 13px;
  color: #333;
  /deep/ .el-checkbox__label {
    color: #333 !important;
  }
  span {
    cursor: pointer;
  }
}
</style>


// WEBPACK FOOTER //
// src/view/right_set/index.vue